(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('.lv-option-group').forEach(function (group) {
        if (group.querySelectorAll('.lv-option-item').length <= 1) {
          group.style.setProperty('display', 'none', 'important');
        }
      });
    }, 400);
  });
  } catch(e) { console.error(e); }
})();

})();
